import { OPEN_CITYSELECT, CLOSE_CITYSELECT } from '../actionTypes/citySelect';

export const openCitySelect = () => ({
    type: OPEN_CITYSELECT
});

export const closeCitySelect = () => ({
    type: CLOSE_CITYSELECT
});
